/**
 * Datatabler jQuery plugin v1.1.6
 * Author: Ángel M. Marqués
 *
 * Copyright 2016, Ángel M. Marqués
 * Released under the MIT license
 */


((window, $, moment, dts) => {
  // <editor-fold desc="Constants">
  const moduleClass = 'datatable-js';
  const preferredTemplate = 'default'; // Used when data-dt-template is not defined
  const DefaultButtonClass = 'btn-sm control'; // Default buttons class
  const CollectionColumnsClass = 'th.dt-collection'; // Selector to build colvis drawer.
  const ExportHiddenColumns = false; // True to include hidden columns in document generators.
  const AutoInitialize = true; // True if plugin should initialize datatable-js concurrences.
  const d = 'data-';
  const prepend = 'dt-';
  const searchDelay = 100; // Delay to trigger column searches. 0 for instant search.
  // </editor-fold>

  // <editor-fold desc="ControlVars">
  // noinspection Eslint
  let isServerSide = false;
  let enableAutoSearches = true;
  // </editor-fold>

  // <editor-fold desc="HelperFunctions">
  // noinspection Eslint
  /**
   * bindWithDelay jQuery plugin
   * Author: Brian Grinstead
   * MIT license: http://www.opensource.org/licenses/mit-license.php
   * http://github.com/bgrins/bindWithDelay
   * http://briangrinstead.com/files/bindWithDelay
   * Usage:
   * See http://api.jquery.com/bind/
   * .bindWithDelay( eventType, [ eventData ], handler(eventObject), timeout, throttle )
   * Examples:
   * $("#foo").bindWithDelay("click", function(e) { }, 100);
   * $(window).bindWithDelay("resize", { optional: "eventData" }, callback, 1000);
   * $(window).bindWithDelay("resize", callback, 1000, true);
   */
  $.fn.bindWithDelay = function (type, data, fn, timeout, throttle) {
    if ($.isFunction(data)) {
      // noinspection Eslint
      throttle = timeout;
      // noinspection Eslint
      timeout = fn;
      // noinspection Eslint
      fn = data;
      // noinspection Eslint
      data = undefined;
    }

    // Allow delayed function to be removed with fn in unbind function
    // noinspection Eslint
    fn.guid = fn.guid || ($.guid && $.guid++);

    // Bind each separately so that each element has its own delay
    // noinspection Eslint
    return this.each(function () {
      let wait = null;

      function cb() {
        // noinspection Eslint
        const e = $.extend(true, {}, arguments[0]);
        const ctx = this;
        // noinspection Eslint
        const throttler = function () {
          wait = null;
          fn.apply(ctx, [e]);
        };

        if (!throttle) {
          clearTimeout(wait);
          wait = null;
        }
        if (!wait) {
          wait = setTimeout(throttler, timeout);
        }
      }

      cb.guid = fn.guid;

      $(this).bind(type, data, cb);
    });
  };

  /**
   * Returns true if element has vertical scrollbar visible or functional
   * @returns {boolean}
   */
  $.fn.hasScrollbar = function hasScrollbar() {
    const divnode = this.get(0);
    return divnode.scrollHeight > divnode.clientHeight;
  };

  /**
   * Función utilizada para seleccionar que columnas se exportarán a los
   * distintos documentos, forzamos la exportación incluyendo en el listado
   * de clases del elemento "TH" la clase 'export-force',
   * y para evitar que se exporte, aun siendo visible usaremos 'export-never'.
   * Si nada se especifica solo se contarán las visibles.
   *
   * @param idx - Index de la columna
   * @param data - Array de datos
   * @param node - Elemento HTML de la columna
   * @returns {*}
   */
  const exportableColumns = (idx, data, node) => {
    if ($(node).hasClass('export-force')) return true;
    if ($(node).hasClass('export-never')) return false;
    if (ExportHiddenColumns === false) {
      return $(node).is(':visible');
    } else if (!$(node).is(':visible')) {
      return true;
    }

    return true;
  };
  // </editor-fold>

  // <editor-fold desc="MainFunctions">
  /**
   * Design a new temporal template based on table datas.
   *
   * @param $t - Target table
   */
  const buildCustomTemplate = ($t) => {
    const template = {};
    let v;
    let v2;

    if ($t.attr(`${d + prepend}keys`)) {
      v = $t.data(`${prepend}keys`);
      template.keys = (v === 1);
    }

    if ($t.attr(`${d + prepend}paging`)) {
      v = $t.data(`${prepend}paging`);
      template.paging = (v === 1);
    }

    if ($t.attr(`${d + prepend}ordering`)) {
      v = $t.data(`${prepend}ordering`);
      template.ordering = (v === 1);
    }

    if ($t.attr(`${d + prepend}searching`)) {
      v = $t.data(`${prepend}searching`);
      template.searching = (v === 1);
    }

    if ($t.attr(`${d + prepend}search--case-insensitive`)) {
      v = $t.data(`${prepend}search--case-insensitive`);
      template.search = {
        caseInsensitive: (v === 1)
      };
    }

    if ($t.attr(`${d + prepend}search--regex`)) {
      v = $t.data(`${prepend}search--regex`);
      template.search = {
        regex: (v === 1)
      };
    }

    if ($t.attr(`${d + prepend}search--smart`)) {
      v = $t.data(`${prepend}search--smart`);
      template.search = {
        smart: (v === 1)
      };
    }

    if ($t.attr(`${d + prepend}search--search`)) {
      // This option sets the default search term
      v = $t.data(`${prepend}search--search`);
      template.search = {
        search: v
      };
    }

    if ($t.attr(`${d + prepend}search-delay`)) {
      // Initial record to be displayed
      v = $t.data(`${prepend}search-delay`);
      template.searchDelay = $.isNumeric(v) && v >= 0 ? v : null;
    }

    if ($t.attr(`${d + prepend}processing`)) {
      v = $t.data(`${prepend}processing`);
      template.processing = (v === 1);
    }

    if ($t.attr(`${d + prepend}fixed-column-l`) || $t.attr(`${d + prepend}fixed-column-r`)) {
      // Initial record to be displayed
      v = $t.attr(`${d + prepend}fixed-column-l`) ? $t.data(`${prepend}fixed-column-l`) : 0;
      v2 = $t.attr(`${d + prepend}fixed-column-r`) ? $t.data(`${prepend}fixed-column-r`) : 0;
      template.fixedColumns = {
        leftColumns: $.isNumeric(v) && v >= 0 ? v : 0,
        rightColumns: $.isNumeric(v2) && v2 >= 0 ? v2 : 0
      };
      template.scrollX = true; // Can be overrided
    }

    if ($t.attr(`${d + prepend}scroll-x`)) {
      v = $t.data(`${prepend}scroll-x`);
      template.scrollX = (v === 1);
    }

    if ($t.attr(`${d + prepend}scroll-y`)) {
      v = $t.data(`${prepend}scroll-y`);
      template.scrollY = v;
      template.scrollCollapse = true; // By default when scrollY is enabled, can be overrided
    }

    if ($t.attr(`${d + prepend}dom`)) {
      v = $t.data(`${prepend}dom`);
      template.dom = v;
    }

    if ($t.attr(`${d + prepend}orders-cells-top`)) {
      v = $t.data(`${prepend}orders-cells-top`);
      template.orderCellsTop = (v === 1);
    }

    if ($t.attr(`${d + prepend}scroll-collapse`)) {
      v = $t.data(`${prepend}scroll-collapse`);
      template.scrollCollapse = (v === 1);
    }

    if ($t.attr(`${d + prepend}order-multi`)) {
      v = $t.data(`${prepend}order-multi`);
      template.orderMulti = (v === 1);
    }

    if ($t.attr(`${d + prepend}paging-type`)) {
      v = $t.data(`${prepend}paging-type`);
      template.pagingType = v;
    }

    if ($t.attr(`${d + prepend}renderer`)) {
      v = $t.data(`${prepend}renderer`);
      template.renderer = v;
    }

    if ($t.attr(`${d + prepend}ajax`)) {
      v = $t.data(`${prepend}ajax`);
      template.ajax = v;

      if ($t.attr(`${d + prepend}ajax-post`)) {
        if ($t.data(`${prepend}ajax-post`) === 1) {
          template.ajax = {
            url: v,
            type: 'POST'
          };
        }
      }
    }

    if ($t.attr(`${d + prepend}filter`)) {
      v = $t.data(`${prepend}filter`);
      template.filter = (v === 1);
    }

    if ($t.attr(`${d + prepend}info`)) {
      v = $t.data(`${prepend}info`);
      template.info = (v === 1);
    }

    if ($t.attr(`${d + prepend}page-length`)) {
      v = $t.data(`${prepend}page-length`);
      template.pageLength = $.isNumeric(v) && v > 0 ? v : 10;
    }

    if ($t.attr(`${d + prepend}display-start`)) {
      // Initial record to be displayed
      v = $t.data(`${prepend}display-start`);
      template.displayStart = $.isNumeric(v) && v >= 0 ? v : 0;
    }

    if ($t.attr(`${d + prepend}auto-width`)) {
      v = $t.data(`${prepend}auto-width`);
      template.autoWidth = (v === 1);
    }

    if ($t.attr(`${d + prepend}defer-render`)) {
      v = $t.data(`${prepend}defer-render`);
      template.deferRender = (v === 1);
    }

    if ($t.attr(`${d + prepend}length-change`)) {
      v = $t.data(`${prepend}length-change`);
      template.lengthChange = (v === 1);
    }

    if ($t.attr(`${d + prepend}server-side`)) {
      // Requires further implementations, method added just for cases when overriding is desired
      v = $t.data(`${prepend}server-side`);
      template.serverSide = (v === 1);
      isServerSide = (v === 1);
    }

    if ($t.attr(`${d + prepend}state-save`)) {
      v = $t.data(`${prepend}state-save`);
      template.stateSave = (v === 1); // May require further implementations, work as it's tho...
    }

    if ($t.attr(`${d + prepend}state-duration`)) {
      // -1 Session storage
      // 86400 (60*60*24) - 1 day
      v = $t.data(`${prepend}state-duration`);
      template.stateDuration = $.isNumeric(v) && v >= -1 ? v : -1;
    }

    if ($t.attr(`${d + prepend}tab-index`)) {
      v = $t.data(`${prepend}tab-index`);
      template.tabIndex = $.isNumeric(v) && v >= 0 ? v : 0;
    }

    if ($t.attr(`${d + prepend}stripe-classes`)) {
      // Comma separated stripe classes
      v = $t.data(`${prepend}stripe-classes`);
      template.stripeClasses = v.split(',');
    }

    return template;
  };

  /**
   * Handle existing search presets.
   *
   * @constructor
   * @param targetId - Table id
   */
  const SetSearchPresets = function SetSearchPresets(targetId) {
    const $form = $(`form[${d}${prepend}search--target="#${targetId}"]`);
    const searchCols = [];

    const getSearchIndex = function getSearchIndex() {
      let index = $(`#${targetId}`).find($(this).data(`${prepend}column`)).index();
      if ($(this).data(`${prepend}column-index`)) {
        index = $(this).data(`${prepend}column-index`);
      }
      return index;
    };

    function FillSpaces() {
      for (let i = 0; i < $(this).data(`${prepend}column`); i += 1) {
        if (typeof searchCols[i] === 'undefined') {
          searchCols[i] = null;
        }
      }
    }

    $form.find(`input.${moduleClass}--search`).each(function inputSearch() {
      if ($(this).val() !== '') {
        FillSpaces.call(this);
        if ($(this).hasClass('date-range')) {
          const dateRangePicker = $(this).data('daterangepicker');
          searchCols[getSearchIndex.call(this)] = { sSearch: `${dateRangePicker.startDate.format('YYYYMMDD')}-${dateRangePicker.endDate.format('YYYYMMDD')}` };
        } else {
          searchCols[getSearchIndex.call(this)] = { sSearch: $(this).val() };
        }
      }
    });

    $form.find(`select.${moduleClass}--search`).each(function selectSearch() {
      if ($(this).val() !== '') {
        FillSpaces.call(this);
        searchCols[getSearchIndex.call(this)] = { sSearch: $(this).val() };
      }
    });

    return {
      searchCols
    };
  };

  /**
   * Perform the form search
   * @param $form
   * @param $searchTable
   */
  function PerformSearch($form, $searchTable) {
    $form.find('input.date-range').each((index, e) => {
      const that = $(`#${$(e).attr('id')}`);
      const picker = that.data('daterangepicker');
      let startDate;
      let endDate;

      if (that.val() !== '') {
        // noinspection Eslint
        if (picker.startDate._isValid && picker.endDate._isValid) {
          startDate = picker.startDate.format('YYYYMMDD');
          endDate = picker.endDate.format('YYYYMMDD');

          $searchTable.DataTable().column(that.data(`${prepend}column`)).search(`${startDate}-${endDate}`, 0, 0);
        }
      }
    });

    $form.find(`input.${moduleClass}--search`).not('.date-range').each((index, e) => {
      $searchTable.DataTable().column($(e).data(`${prepend}column`)).search($(e).val(), 0, 0);
    });

    $form.find(`select.${moduleClass}--search`).each((index, e) => {
      $searchTable.DataTable().column($(e).data(`${prepend}column`)).search($(e).val(), 0, 0);
    });

    $searchTable.DataTable().draw();
  }

  const fixLengthMenu = function fixLengthMenu(totalRows = null, settings, method = 'OPTION_REMOVER') {
    // noinspection Eslint
    const minValue = settings._iDisplayLength;
    let originalRange = settings.aLengthMenu[0];

    function roundUp(x) {
      let z = x;
      // noinspection Eslint
      const y = Math.pow(10, (z.toString().length - 1));
      z /= y;
      z = Math.ceil(z);
      z *= y;
      return z;
    }

    if (totalRows != null) {
      if (totalRows <= minValue) {
        originalRange = [-1];
      }
      switch (method) {
        case 'OPTION_REMOVER': {
          for (let ix = 0; ix <= originalRange.length; ix += 1) {
            const curretRangeValue = originalRange[ix];
            if (curretRangeValue !== -1) {
              if (curretRangeValue >= totalRows) {
                originalRange.splice(ix, (originalRange.length - ix) - 1);
              }
            }
          }

          const $lengthSelect = $('.dataTables_length').find('select');

          $lengthSelect.empty();

          const data = [];
          for (let j = 0; j < originalRange.length; j += 1) {
            const selected = originalRange[j] === minValue ? 'selected' : '';
            const text = originalRange[j] === -1 ? 'Mostrar todo' : originalRange[j];
            const option = `<option ${selected} value="${originalRange[j]}">${text}</option>`;
            $lengthSelect.append(option);

            data.push({
              id: originalRange[j],
              text: originalRange[j] === -1 ? 'Mostrar todo' : originalRange[j]
            });
          }
          // TODO: Enable Select2 styling
          /* $lengthSelect.select2({
           'theme': 'bootstrap',
           'minimumResultsForSearch': Infinity
           }); */
          break;
        }
        case 'RANGE_CALC': {
          const steps = 7;
          const options = [];

          // noinspection Eslint
          const ratio = Math.pow((totalRows / minValue), (1 / steps));

          let phase = minValue;
          for (let i = 0; i < steps; i += 1) {
            const rs = (phase * ratio);
            options.push(roundUp(Math.ceil(rs)));
            phase = rs;
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  };


  /**
   * Handle form searches.
   *
   * @constructor
   * @param targetId - Table id
   */
  const InitializeSearchFilters = function InitializeSearchFilters(targetId) {
    const $form = $(`form[${d}${prepend}search--target="#${targetId}"]`);
    const $searchTable = $(`#${targetId}`);
    const $searchButton = $form.find(`.${moduleClass}--search-submit`);
    const $resetButton = $form.find(`.${moduleClass}--search-reset`);
    let autoSearch = true;

    if ($searchButton.length > 0) {
      autoSearch = false;

      $searchButton.on('click', (e) => {
        e.preventDefault();

        PerformSearch($form, $searchTable);
      });
    }

    if ($resetButton.length > 0) {
      $resetButton.on('click', (e) => {
        e.preventDefault();

        function emptySearch($element) {
          $searchTable.DataTable().column($element.data(`${prepend}column`)).search('', 0, 0);
        }

        $form.find(`select.${moduleClass}--search`).each((index, ele) => {
          if ($(ele).attr(`${d + prepend}persist`)) {
            const persisted = $(ele).data(`${prepend}persist`);
            if (persisted !== true && persisted !== 1) {
              $(ele).val('').trigger('change');
              emptySearch($(ele));
            }
          } else {
            $(ele).val('').trigger('change');
            emptySearch($(ele));
          }
        });

        $form.find('input.date-range').each((index, ele) => {
          const that = $(`#${$(ele).attr('id')}`);

          function resetInput() {
            $(that).data('daterangepicker').setStartDate(moment());
            $(that).data('daterangepicker').setEndDate(moment());
            $(that).val('').change();

            $searchTable.DataTable().column($(that).data('dt-column')).search('', 0, 0);
            emptySearch($(ele));
          }

          if (that.attr(`${d + prepend}persist`)) {
            const persisted = that.data(`${prepend}persist`);
            if (persisted !== true && persisted !== 1) {
              resetInput.call(ele);
            }
          } else {
            resetInput.call(ele);
          }
        });

        $form.find(`input.${moduleClass}--search`).not('.date-range').each((index, ele) => {
          if ($(ele).attr(`${d + prepend}persist`)) {
            const persisted = $(ele).data(`${prepend}persist`);
            if (persisted === true || persisted === 1) {
              $searchTable.DataTable().column($(ele).data(`${prepend}column`)).search($(ele).val(), 0, 0);
            } else {
              $(ele).val('');
              emptySearch($(ele));
            }
          } else {
            $(ele).val('');
            emptySearch($(ele));
          }
        });

        if ($resetButton.attr(`${d + prepend}auto-search`)) {
          $searchTable.DataTable().search('')/* .columns().search('') */.draw(false);
        }
      });
    }

    function generateSearchBehaviour() {
      let column = null;
      let regex;
      let smart;
      let forceAutoSearch = false;

      if ($(this).attr(`${d + prepend}column`)) {
        column = $(this).data(`${prepend}column`);
      }

      if ($(this).attr(`${d + prepend}regex`)) {
        const dataRegex = $(this).data(`${prepend}regex`);
        regex = (dataRegex === true || dataRegex === 1);
      }

      if ($(this).attr(`${d + prepend}smart`)) {
        const dataSmart = $(this).data(`${prepend}smart`);
        smart = (dataSmart === true || dataSmart === 1);
      }

      if ($(this).attr(`${d + prepend}force-auto-search`)) {
        const dataAutoSearch = $(this).data(`${prepend}force-auto-search`);
        forceAutoSearch = (dataAutoSearch === true || dataAutoSearch === 1);
      }

      if (column != null) {
        $searchTable.DataTable().column($(this).data(`${prepend}column`)).search(
          $(this).val(),
          regex,
          smart
        );

        if ((autoSearch || forceAutoSearch) && enableAutoSearches) {
          $searchTable.DataTable().draw();
        }
      }
    }

    $form.find('input.date-range').each((index, ele) => {
      const that = $(`#${$(ele).attr('id')}`);
      let forceAutoSearch = false;

      if ($(ele).attr(`${d + prepend}force-auto-search`)) {
        const dataAutoSearch = $(ele).data(`${prepend}force-auto-search`);
        forceAutoSearch = (dataAutoSearch === true || dataAutoSearch === 1);
      }

      function CancelDateRangePicker() {
        $(that).val('').change();
        $searchTable.DataTable().column($(that).data('dt-column')).search('');

        if ((autoSearch || forceAutoSearch) && enableAutoSearches) {
          $searchTable.DataTable().draw();
        }
      }

      if ($(that).data('daterangepicker') !== undefined) {
        $(that).on('apply.daterangepicker', (ev, picker) => {
          let startDate;
          let endDate;

          // noinspection Eslint
          if (picker.startDate._isValid && picker.endDate._isValid) {
            startDate = picker.startDate.format('YYYYMMDD');
            endDate = picker.endDate.format('YYYYMMDD');

            $(ev.target).val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`).change();
            $searchTable.DataTable().column($(that).data('dt-column')).search(`${startDate}-${endDate}`, 0, 0);
          } else {
            $(ev.target).val('').change();
            $searchTable.DataTable().column($(that).data('dt-column')).search('');
          }

          if ((autoSearch || forceAutoSearch) && enableAutoSearches) {
            $searchTable.DataTable().draw();
          }
        });

        $(that).on('cancel.daterangepicker', () => {
          CancelDateRangePicker.call(that);
        });

        $(that).next('.date-range--eraser').on('click', () => {
          CancelDateRangePicker.call(that);
        });
      }
    });

    $form.find(`input.${moduleClass}--search`).each((index, e) => {
      $(e).bindWithDelay('keyup change', () => {
        generateSearchBehaviour.call(e);
      }, searchDelay);
    });

    $form.find(`select.${moduleClass}--search`).each((index, e) => {
      $(e).bindWithDelay('change', () => {
        generateSearchBehaviour.call(e);
      }, searchDelay);
    });
  };
  // </editor-fold>

  // <editor-fold desc="Button Templates">
  // noinspection Eslint
  const excelHtml5__BUTTON = {
    extend: 'excelHtml5',
    text: '<!--<i class="fa fa-file-excel-o fa-fw-o"></i> -->Excel',
    className: DefaultButtonClass,
    exportOptions: {
      columns: exportableColumns
    }
  };

  // noinspection Eslint
  let pdf__BUTTON = {
    extend: 'pdf',
    text: '<!--<i class="fa fa-file-pdf-o fa-fw-o"></i> -->PDF',
    className: DefaultButtonClass,
    exportOptions: {
      columns: exportableColumns
    }
  };

  // noinspection JSUnusedLocalSymbols, Eslint
  const collection__BUTTON = {
    extend: 'collection',
    text: '<!--<span class="fa fa-eye fa-lg"></span> -->Columnas visibles <i class="fa fa-caret-down fa-fw"></i>',
    buttons: [{
      extend: 'columnsToggle',
      columns: CollectionColumnsClass
    }],
    postfixButtons: [{
      extend: 'colvisRestore',
      text: 'Mostrar todo'
    }],
    className: DefaultButtonClass
  };

  // noinspection JSUnusedLocalSymbols, Eslint
  const colvis__BUTTON = {
    extend: 'colvis',
    text: '<!--<span class="fa fa-eye fa-lg"></span> -->Columnas visibles <i class="fa fa-caret-down fa-fw"></i>',
    columns: CollectionColumnsClass,
    postfixButtons: [
      {
        extend: 'colvisRestore',
        text: 'Mostrar todo'
      }
    ],
    className: DefaultButtonClass
  };
  // </editor-fold>

  // <editor-fold desc="Templates">
  dts.template_empty = {
    paging: false,
    filter: false,
    info: false,
    ordering: false
  };

  function BuildDefaultTemplate() {
    // noinspection Eslint
    dts.template_default = {
      keys: false,
      renderer: 'bootstrap',
      paging: true,
      dom: '<"pull-right datatable-toolbar"B>lT<"pull-right"f>tr<"row"<"col-xs-6"<"vcenter"i>><"col-xs-6"p>>',
      lengthMenu: [[10, 25, 50, 100, 300, 500, 1000, 5000, 10000, 20000, -1], [10, 25, 50, 100, 300, 500, 1000, 5000, 10000, 20000, 'Mostrar todo']],
      pageLength: 10,
      buttons: [
        excelHtml5__BUTTON,
        pdf__BUTTON,
        colvis__BUTTON
      ],
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.12/i18n/Spanish.json'
      }
    };
  }

  dts.template_generated = {};
  // </editor-fold>

  $.fn.datatabler = function datatabler(customParams = {}, autoInit = true) {
    const $table = $(this);
    let tableId = null;
    let dt = null;

    // Case class datatable-js is wrongly applied.
    if (!$table.is('table')) {
      console.warn(`WARN: ${moduleClass} can only be applied to tables. Wrong usage on next element:`, $table);
      return;
    }

    if ($table.prop('id').length > 0) tableId = $table.prop('id');

    if (typeof dtProjectTemplate === 'undefined') {
      window.dtProjectTemplate = {};
    }


    function initDatatable() {
      BuildDefaultTemplate();
      const requestedTemplate = `template_${$table.attr(`${d + prepend}template`) ? $table.data(`${prepend}template`) : preferredTemplate}`;
      let template = dts[requestedTemplate];

      // If requested template does not exist.
      if (typeof template === 'undefined') {
        template = dts[`template_${preferredTemplate}`];
        console.warn(`WARN: Requested template '${requestedTemplate}' is not defined. ` +
          `Preferred template '${preferredTemplate}' used instead.`);
      }
      dts.template_generated = buildCustomTemplate($table);
      let settings = $.extend({}, template, window.dtProjectTemplate);
      settings = $.extend({}, settings, dts.template_generated);
      settings = $.extend({}, settings, customParams);

      // Extender la definición de columnas
      if (window.dtProjectTemplate.columnDefs) {
        settings.columnDefs = [...settings.columnDefs, ...window.dtProjectTemplate.columnDefs];
      }

      if (tableId) {
        settings = $.extend({}, settings, SetSearchPresets(tableId));
      }

      const $parentPanel = $table.closest('.modal');
      if ($parentPanel.length > 0 && autoInit === true && !$parentPanel.hasClass('external-data')) {
        $parentPanel.off('shown.bs.modal').on('shown.bs.modal', () => {
          console.info('Table is inside a modal. Execution deferred.');
          dt = $table.DataTable(settings);
        });
      } else {
        dt = $table.DataTable(settings);
      }

      if (tableId) {
        InitializeSearchFilters(tableId);
      }

      $table.on('draw.dt', () => {
        // noinspection Eslint
        if (settings.serverSide) {
          fixLengthMenu($table.DataTable().settings()[0]._iRecordsDisplay,
            $table.DataTable().settings()[0]);
        }
        /* let $divScroll = $table.parent('.dataTables_scrollBody');
         if ($divScroll.length > 0) {
         if (!$divScroll.hasScrollbar()) {
         $divScroll.on('mousewheel DOMMouseScroll', function (event) {
         let delta = Math.max(-1, Math.min(1, (event.originalEvent.wheelDelta
         || -event.originalEvent.detail)));
         $divScroll.scrollLeft($divScroll.scrollLeft() - ( delta * 40 ));
         event.preventDefault();
         });
         }
         } */
      });
    }

    if (autoInit) {
      initDatatable();
    }

    // noinspection Eslint
    return {
      init: function init() {
        initDatatable();
      },
      disableSearch: function disableAutoSearch() {
        enableAutoSearches = false;
      },
      enableSearch: function enableAutoSearch() {
        enableAutoSearches = true;
      },
      search: function search() {
        PerformSearch($(`form[${d}${prepend}search--target="#${tableId}"]`), $table);
      },
      getDatatable: function getDatatable() {
        return dt;
      },
      extendPdfButton: function extendPdfButton(params) {
        // noinspection Eslint
        pdf__BUTTON = $.extend({}, pdf__BUTTON, params);
      }
    };
  };

  if (AutoInitialize) {
    $(document).ready(() => {
      $(`.${moduleClass}`).each((index, e) => {
        if ($(e).attr(`${d + prepend}custom`)) {
          const val = $(e).data(`${prepend}custom`);
          if (val === 1) {
            return;
          }
        }
        $(e).datatabler();
      });
    });
  }
})(window, jQuery, moment, {});
